import React from 'react';
import { Card, Typography, Space } from 'antd';
import { Link } from 'react-router-dom';

const { Title, Text, Paragraph } = Typography;

export const PrivacyPolicyPage: React.FC = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        padding: '24px 16px',
        backgroundColor: '#F0F9F4',
        minHeight: '80vh'
      }}
    >
      <Card
        style={{
          width: '100%',
          maxWidth: 980,
          borderRadius: 12
        }}
      >
        <Space direction="vertical" size="middle" style={{ width: '100%' }}>
          <Title level={2} style={{ marginBottom: 0 }}>Политика конфиденциальности</Title>
          <Text type="secondary">Последнее обновление: 29.04.2026</Text>

          <Paragraph>
            Настоящая политика описывает, какие данные собирает и обрабатывает сервис
            compass mum, а также как эти данные защищаются.
          </Paragraph>

          <Title level={4}>1. Какие данные мы обрабатываем</Title>
          <Paragraph>
            Мы можем обрабатывать регистрационные данные (email, телефон, ФИО), данные
            профиля беременности, записи дневников, файлы, историю взаимодействия с сервисом,
            технические данные запросов и информацию, необходимую для поддержки и безопасности.
          </Paragraph>

          <Title level={4}>2. Цели обработки</Title>
          <Paragraph>
            Данные используются для предоставления функциональности сервиса, ведения дневников,
            взаимодействия с врачом, улучшения качества работы приложения, соблюдения требований
            законодательства и обеспечения информационной безопасности.
          </Paragraph>

          <Title level={4}>3. Хранение и защита</Title>
          <Paragraph>
            Мы применяем организационные и технические меры защиты, включая контроль доступа,
            журналирование и ограничение обработки персональных данных только в рамках
            необходимых бизнес-процессов.
          </Paragraph>

          <Title level={4}>4. Передача данных третьим лицам</Title>
          <Paragraph>
            Передача данных третьим лицам осуществляется только при наличии законных оснований,
            необходимости оказания сервиса или по запросу уполномоченных органов в рамках
            действующего законодательства.
          </Paragraph>

          <Title level={4}>5. Права пользователя</Title>
          <Paragraph>
            Пользователь вправе запросить актуализацию, исправление или удаление персональных
            данных, а также получить информацию об обработке данных в пределах, предусмотренных
            законом.
          </Paragraph>

          <Title level={4}>6. Контакты</Title>
          <Paragraph>
            По вопросам обработки персональных данных и конфиденциальности вы можете обратиться
            в службу поддержки сервиса.
          </Paragraph>

          <Paragraph style={{ marginBottom: 0 }}>
            <Link to="/">Вернуться на главную</Link>
          </Paragraph>
        </Space>
      </Card>
    </div>
  );
};
